import { apiClient } from './apiClient';

export interface SystemOverviewData {
  dc_capacity_mwp: number;
  ac_capacity_mw: number;
  generation_kwh: number;
  active_power_kw: number;
  active_power_ac_mw: number;
}

export interface EnvironmentalImpactData {
  co2_saved_tons: number;
  trees_saved_k: number;
}

export interface AssetStatusData {
  connected: number;
  disconnected: number;
  total: number;
}

export interface PerformanceMetrics {
  energy_export_import: number;
  specific_yield: number;
  cuf: number;
  pr: number;
  energy_loss: number;
  plant_availability: number;
  grid_availability: number;
}

export interface DailyPerformanceData {
  date: string;
  dc_capacity: number;
  ac_capacity: number;
  cuf: number;
  pr: number;
  energy_kwh: number;
  poa_irradiance: number;
  poa_energy: number;
  grid_availability: number;
  plant_availability: number;
}

export const systemOverviewService = {
  getSystemOverview: async (plantId?: string): Promise<SystemOverviewData> => {
    // Mock data for visualization
    return {
      dc_capacity_mwp: 6.25,
      ac_capacity_mw: 5.38,
      generation_kwh: 0.00,
      active_power_kw: 0.00,
      active_power_ac_mw: 0.32
    };
    
    // Uncomment to use real API
    // const params = plantId ? `?plant_id=${plantId}` : '';
    // const response = await apiClient.get(`/api/system/overview${params}`);
    // return response.data;
  },

  getEnvironmentalImpact: async (plantId?: string): Promise<EnvironmentalImpactData> => {
    // Mock data for visualization
    return {
      co2_saved_tons: 117.55,
      trees_saved_k: 5.28
    };
    
    // Uncomment to use real API
    // const params = plantId ? `?plant_id=${plantId}` : '';
    // const response = await apiClient.get(`/api/environmental-impact${params}`);
    // return response.data;
  },

  getAssetStatus: async (plantId?: string): Promise<AssetStatusData> => {
    // Mock data for visualization
    return {
      connected: 0,
      disconnected: 1,
      total: 1
    };
    
    // Uncomment to use real API
    // const params = plantId ? `?plant_id=${plantId}` : '';
    // const response = await apiClient.get(`/api/assets/status${params}`);
    // return response.data;
  },

  getPerformanceMetrics: async (plantId?: string): Promise<PerformanceMetrics> => {
    // Mock data for visualization
    return {
      energy_export_import: 0,
      specific_yield: 6.86,
      cuf: 0,
      pr: 0,
      energy_loss: 0,
      plant_availability: 0,
      grid_availability: 0
    };
    
    // Uncomment to use real API
    // const params = plantId ? `?plant_id=${plantId}` : '';
    // const response = await apiClient.get(`/api/performance/metrics${params}`);
    // return response.data;
  },

  getPerformanceTable: async (plantId?: string): Promise<DailyPerformanceData[]> => {
    // Mock data for visualization
    return Array.from({ length: 10 }, (_, i) => ({
      date: `2025-01-${String(i + 1).padStart(2, '0')}`,
      dc_capacity: 6.25,
      ac_capacity: 5.38,
      cuf: Math.random() * 30 + 10,
      pr: Math.random() * 20 + 80,
      energy_kwh: Math.random() * 5000 + 15000,
      poa_irradiance: Math.random() * 2 + 4,
      poa_energy: Math.random() * 100 + 200,
      grid_availability: Math.random() * 10 + 90,
      plant_availability: Math.random() * 15 + 85
    }));
    
    // Uncomment to use real API
    // const params = plantId ? `?plant_id=${plantId}` : '';
    // const response = await apiClient.get(`/api/performance/table${params}`);
    // return response.data;
  }
};